import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { actionCreators } from '../actions/globalAction';
import { Loader } from '../components/solar/Loader';

export class Pagination extends Component {
    constructor(props) {
        super(props);
        this.setDiagrammTitle = this.setDiagrammTitle.bind(this);
        this.startLoader = this.startLoader.bind(this);
        this.state = { showLoading: false };
    }

    componentDidUpdate() {
        // Container-Data geladen → Loader ausblenden
        if (this.props.prop.isLoaded && this.state.showLoading) {
            this.setState({ showLoading: false });
        }
    }

    startLoader() {
        this.setState({ showLoading: true });
    }

    setDiagrammTitle(dt, options, onlyYear) {
        let month = dt.toLocaleString("en-us", { month: "long" });
        // Safely create the Chart.js v4 plugins.title block if it doesn't exist yet
        if (!options.plugins) options.plugins = {};
        if (!options.plugins.title) options.plugins.title = {};
        if (!onlyYear)
            options.plugins.title.display = true;
        if (!onlyYear)
            options.plugins.title.text = "Solarenergie-mehl im " + month + " " + dt.getFullYear();
        else {
            options.plugins.title.display = true;
            options.plugins.title.text = "Solarenergie-mehl im Jahr " + dt.getFullYear();
        }
    }

    render() {
        let dt = new Date();
        let m = this.props.prop.match.params.Month || dt.getMonth();
        if (typeof (this.props.prop.match.params.Month) !== 'undefined' && !isNaN(parseInt(m)) && isFinite(m)) m = parseInt(m - 1);
        let y = this.props.prop.match.params.Year || dt.getFullYear();
        if (!isNaN(parseInt(y)) && isFinite(y)) y = parseInt(y);

        dt = new Date(y, m, dt.getDay());
        if (typeof (this.props.options) !== 'undefined' && this.props.options !== null) {
            this.setDiagrammTitle(dt, this.props.options, this.props.onlyYear);
        }
        let n = new Date(dt.getTime());
        let p = new Date(dt.getTime());

        let next = 0;
        let prev = 0;
        if (this.props.onlyYear) {
            next = new Date(n.setFullYear(n.getFullYear() + 1));
            prev = new Date(p.setFullYear(p.getFullYear() - 1));
        }
        else {
            next = new Date(n.setMonth(m + 1));
            prev = new Date(p.setMonth(m - 1));
        }

        let nextYear = (this.props.nextYear || next.getFullYear());
        let nextMonth = (this.props.nextMonth || next.getMonth() + 1);
        let prevYear = (this.props.prevYear || prev.getFullYear());
        let prevMonth = (this.props.prevMonth || prev.getMonth() + 1);
        
        if (this.props.onlyYear) {
            return <div className='d-flex justify-content-between align-items-center'>
                <Link className='btn btn-secondary' onClick={() => this.startLoader()} to={`/${this.props.routeSegment}/${prevYear}`}>Previous</Link>
                <small className='text-muted'>{prevYear} / {nextYear}</small>
                <Link className='btn btn-secondary' onClick={() => this.startLoader()} to={`/${this.props.routeSegment}/${nextYear}`}>Next</Link>
                <Loader show={this.state.showLoading} />
            </div>;
        }

        return <div className='d-flex justify-content-between align-items-center'>
            <Link className='btn btn-secondary' onClick={() => this.startLoader()} to={`/${this.props.routeSegment}/${prevYear}/${prevMonth}`}>Previous</Link>
            <small className='text-muted'>{prevYear}/{prevMonth} — {nextYear}/{nextMonth}</small>
            <Link className='btn btn-secondary' onClick={() => this.startLoader()} to={`/${this.props.routeSegment}/${nextYear}/${nextMonth}`}>Next</Link>
            <Loader show={this.state.showLoading} />
        </div>;
    }
}
export default connect(
    state => state.globalReducer,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(Pagination);